import { AccessTypes, LayoutViewModel } from '../GraphQL.Default';

export const DEFAULT_LAYOUT_VIEW_MODEL: LayoutViewModel = {
    accessType: AccessTypes.Unauthenticated,
    customerServicePhone: '',
    greetingFirstName: '',
    internalHostUrl: '/iojs/',
    isLoggedIn: false,
    isRapidCash: false,
    isReferralCodeEnabled: false,
    isProduction: false,
    lenderKey: 0,
    loanCount: 0,
    persistedMessage: undefined,
    secureSiteAddress: '/',
    sessionInfo: '',
    showApplyNowButton: true,
    siteAddress: '/',
    requiresPasswordReset: false
};
